import { Component, inject } from '@angular/core';
import { GlobalEventDispatcher } from '@ps20-frontend/shop-integration-redux';
import { NgRedux, select } from '@angular-redux3/store';
import { App } from '@ps20-frontend/frontend-models';
import { Observable } from 'rxjs';
import { LazyElementDirective } from '@angular-extensions/elements';
import { AsyncPipe } from '@angular/common';
import { IAppState } from '../../store/localStore';
import { loadAppConfig } from '../../store/local.actions';
import {
  appSourcePathConfigSelectorGenerator,
  selectShowPhAngebot,
} from '../../store/selectors/app.selectors';

@Component({
  selector: 'ps20-shop-ph-angebot',
  templateUrl: './ph-angebot.component.html',
  imports: [LazyElementDirective, AsyncPipe],
})
export class PhAngebotComponent {
  globalEventDispatcher: GlobalEventDispatcher = GlobalEventDispatcher.getInstance();

  @select(appSourcePathConfigSelectorGenerator(App.PH))
  mainFilename$: Observable<string>;

  @select(selectShowPhAngebot)
  selectShowAngebot$: Observable<boolean>;

  constructor() {
    const ngRedux = inject<NgRedux<IAppState>>(NgRedux);

    ngRedux.dispatch(loadAppConfig(App.PH));
  }
}
